import styled from '@emotion/styled';
import { typography } from 'src/theme/typography';

const CreateMultipleQuoteStyle = styled('div')`
    ${typography.bodyXs}
    color: var(--sand-700);
    .sub-title {
        ${typography.bodyL}
        margin-bottom: 16px;
    }
    .wrap-quote {
        overflow-y: auto;
        max-height: calc(100vh - 320px);
        .ant-flex {
            padding: 8px 0;
        }
        .ant-checkbox-wrapper {
            ${typography.bodyXs}
            min-width: 100px;
            color: var(--sand-700);
        }
    }

    .btn-group {
        ${typography.bodySm}
        margin-top: 24px;
        .ant-btn {
            ${typography.buttonMd}
            border-radius: 6px;
        }
    }
`;

export default CreateMultipleQuoteStyle;
